module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<img src="' +
__e( thumbnailUrl ) +
'" class="youtube-thumbnail"/>\n<span class="video-time">' +
__e( displayDuration ) +
'</span>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/youtube/YouTubeImageView.tpl
// module id = 1025
// module chunks = 0